const GlobalFooter = () => {
  const handleCollapsibleHeaderClick: EventListener = event => {
    const button = event.currentTarget as HTMLElement;
    const parent = button.parentElement;

    if (parent) {
      parent.classList.toggle('active');
    }
  };
  const setUpButtons = () => {
    const elNavBtns = document.querySelectorAll('.js-collapsible li.lh');
    elNavBtns.forEach(elNavBtn => {
      elNavBtn.addEventListener('click', handleCollapsibleHeaderClick);
    });
  };
  const initGlobalFooter = () => {
    setUpButtons();
  };

  return {
    initGlobalFooter,
  };
};

export default GlobalFooter;
